// Need to use the React-specific entry point to import createApi

import { baseApi } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const restaurantApi = baseApi.injectEndpoints({
  // reducerPath: "restaurantApi",

  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getAllRestaurant: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `restaurants?${queryString}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllRestaurantQuery } = restaurantApi;
